import { SecuredWsApi } from "@/utils/http-client";

export default {
  getPaymentMethods(payerUserId, transactionId) {
    return SecuredWsApi.get(`/api/paymentflow/v1/payer/${payerUserId}/payment-methods`, { transactionId });
  },
  getPayerDetails(transactionId) {
    return SecuredWsApi.get("/api/paymentflow/v1/payer-details", { transactionId });
  },
  verifyEmailAddress(transactionId, payload) {
    const apiUrl = SecuredWsApi.getUrl("/api/paymentflow/v1/guestsavepayerverify", { transactionId });
    return SecuredWsApi.post(apiUrl, payload);
  },
  addOrUpdateCreditCard(payerUserId, payload) {
    if (payload.UniquePayerReferenceId) {
      return SecuredWsApi.put(`/api/paymentflow/v1/payer/${payerUserId}/credit-card`, payload);
    } else {
      return SecuredWsApi.post(`/api/paymentflow/v1/payer/${payerUserId}/credit-card`, payload);
    }
  },
  addOrUpdateBankDebit(payerUserId, payload) {
    if (payload.UniquePayerReferenceId) {
      return SecuredWsApi.put(`/api/paymentflow/v1/payer/${payerUserId}/bank-account`, payload);
    } else {
      return SecuredWsApi.post(`/api/paymentflow/v1/payer/${payerUserId}/bank-account`, payload);
    }
  },
  createNewPayer(transactionId, payload) {
    const apiUrl = SecuredWsApi.getUrl("/api/paymentflow/v1/guestsavepayer", { transactionId });
    return SecuredWsApi.post(apiUrl, payload);
  },
  updatePayerTermsOnLogin(transactionId, payload) {
    const apiUrl = SecuredWsApi.getUrl(`/api/paymentflow/v1/payer/terms-and-conditions`, { transactionId });
    return SecuredWsApi.post(apiUrl, payload);
  },
  updateCreditCardAVSDetails(payerUserId, payload) {
    return SecuredWsApi.put(`/api/paymentflow/v1/payer/${payerUserId}/credit-card-avs`, payload);
  },
};
